import { render, staticRenderFns } from "./StoreInformationDialog.vue?vue&type=template&id=b00afc2a&scoped=true&"
import script from "./StoreInformationDialog.vue?vue&type=script&lang=js&"
export * from "./StoreInformationDialog.vue?vue&type=script&lang=js&"
import style0 from "./StoreInformationDialog.vue?vue&type=style&index=0&id=b00afc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00afc2a",
  null
  
)

export default component.exports